import { FILE } from "../actions";

const defaultState = {
  files: [
    { name: "", blob: "", type: "DECISION_RULES", updateAt: 0 },
    { name: "", blob: "", type: "ACCOUNTS", updateAt: 0 },
    { name: "", blob: "", type: "EXCLUDED_CLIENT", updateAt: 0 },
    { name: "", blob: "", type: "CLIENT_NAMES", updateAt: 0 }
  ],
  loading: false,
  error: true,
  downloading: false,
  downloadedKnow: null,
  uploadLearningFileData: null
};

const loading = state => ({ ...state, loading: true, error: false });
const fetchSuccess = (state, { payload }) => {
  return {
    ...state,
    files: [
      ...state.files.map(x => {
        return payload.find(y => y.type === x.type) || x;
      })
    ],
    loading: false,
    error: false
  };
};
const fillError = state => ({
  ...state,
  loading: false,
  error: true,
  downloading: false
});
const uploadSuccess = (state, { payload }) => ({
  ...state,
  files: [...state.files.filter(x => x.type !== payload.type), payload],
  loading: false,
  error: false
});
const downloadSuccess = (state, { payload }) => ({
  ...state,
  downloadedKnow: payload,
  loading: false,
  error: false,
  downloading: false
});
const ACTION_HANDLERS = {
  [FILE.UPLOAD_SUCCESS]: uploadSuccess,
  [FILE.UPLOAD_ERROR]: fillError,
  [FILE.LOADING]: loading,
  [FILE.FETCH_SUCCESS]: fetchSuccess,
  [FILE.FETCH_ERROR]: fillError,
  [FILE.FETCH_KNOW_SUCCESS]: downloadSuccess,
  [FILE.UPLOAD_LEARNING_FILE_DATA_SUCCESS]: (state, { payload }) => ({
    ...state,
    uploadLearningFileData: payload,
    loading: false,
    error: false
  })
};

export default (state = defaultState, action = "") => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
